import { Entity } from '@api';
import { NonLinearStepper } from '@terminal/components/non-linear-stepper/NonLinearStepper';
import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { AssetOverviewContent } from '@terminal/widgets/company-to-theme-widget/tabs/assets-overview-tab/asset-overview-content/AssetOverviewContent';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CompetitorDetail.module.scss';

export const CompetitorDetail = ({
  entity,
  competitor,
}: {
  entity: Entity;
  competitor: Entity;
}) => {
  const { t } = useTranslation(['widget']);
  const { getThemedLogoUrl } = useThemeStore();

  return (
    <>
      <div className={styles.stepperWrapper}>
        <NonLinearStepper
          activeIndex={1}
          iconSize={18}
          steps={[
            {
              logoUrl: getThemedLogoUrl(entity),
              hoverLabel: entity.name_short || entity.name,
              connectorLabel: t(
                'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.connectorLabel'
              ),
              highlightConnector: false,
              isSimple: false,
            },
            {
              logoUrl: getThemedLogoUrl(competitor),
              hoverLabel: competitor.name_short || competitor.name,
              highlightConnector: false,
            },
          ]}
        />
      </div>
      <AssetOverviewContent
        entity={competitor}
        source={POSTHOG_TRACKING_SOURCES.COMPETITORS_DRAWER}
      />
    </>
  );
};
